// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cart-header{padding-bottom:0!important;padding-top:27px!important}", ""]);
// Exports
module.exports = exports;
